export default {
  VerifyModal: {
    title: "Confirmez votre compte",
    send: "Soumettre pour examen",
    step1: {
      reason:
        "Ce service est exclusivement réservé aux professionnels de santé ; l'accès à certaines fonctionnalités est donc limité aux utilisateurs vérifiés. Cela permet de garantir :",
      reasons: {
        1: "L'exclusion des patients et des personnes non autorisées",
        2: "La création d'une communauté professionnelle pour l'échange de connaissances et d'expériences",
        3: "Le maintien des normes éthiques et des standards de traitement des données",
      },
      end: "Nous accordons une grande importance à votre sécurité et à votre confidentialité. Toutes les informations collectées sont uniquement utilisées pour vérifier votre statut et sont supprimées une fois le processus terminé.",
      status: "Statut",
      statuses: {
        doctor: "Médecin",
        student: "Étudiant",
        ordinator: "Résident",
      },
    },
    step2: {
      agenda:
        "Toutes les données soumises sont protégées et utilisées exclusivement dans le cadre de la vérification de votre statut.",
      chooseVerifyWay: "Choisissez une méthode de vérification",
      ways: {
        1: "Diplôme, certificat ou licence",
        2: "Lien vers votre profil vérifié sur un agrégateur médical (ProDoctors, DocDoc, etc.)",
        3: "Lien vers votre profil sur le site Web d'une clinique",
        4: "Télécharger un diplôme en éducation médicale",
        5: "Télécharger une carte d'étudiant d'une université de médecine",
      },
      selectFile: "Sélectionner un fichier",
      sendToCheck: "Soumettre pour examen",
      pasteLink: "Coller le lien",
      notAllowedFile: "Seuls les fichiers PDF et images sont autorisés",
      noMoreFiles: "Nombre maximal de fichiers autorisés : ",
    },
    step3: {
      processing: {
        title: "Document envoyé pour examen",
        text1_1:
          "Nous allons examiner vos informations. Vous recevrez une notification par e-mail une fois le processus terminé.",
        text2: "La vérification prend généralement un jour ouvrable.",
      },
      rejected: {
        title: "Compte non vérifié",
        text1_1:
          "Votre soumission n'a pas été validée. Veuillez fournir des données valides. La vérification est nécessaire pour accéder au téléchargement et au traitement des études assistés par l'IA.",
        text1_2: "Réessayer",
      },
    },
  },
};
